/** Chat API + open helper (same contract as accessnowcare `/api/chat`). */

import { getApiUrl } from '@/lib/api-url';

export const CHAT_BUTTON_ID = 'vapi-widget-floating-button';
export const CHAT_OPEN_EVENT = 'ahealth:open-chat';

export function getChatApiUrl(): string {
  return `${getApiUrl()}/chat`;
}
export function openChatBot(): void {
  window.dispatchEvent(new CustomEvent(CHAT_OPEN_EVENT));
  document.getElementById(CHAT_BUTTON_ID)?.click();
}
